export default __webpack_public_path__ + "static/media/GitHub.b87199c5.svg";